import { createAction } from '@reduxjs/toolkit';
import { PaymentMethod } from '@box/redux/types';

export const setSelectedMethod = createAction<PaymentMethod>(
  'finance/paymentMethods/setSelectedMethod'
);
